<template>
  <div class="footer">
    <div class="links">
      <a href="https://www.laixue.com/site/honour.html">公司荣誉</a>
      <a href="/about.html">公司介绍</a>
      <a href="/agreement.html?type=USER">用户协议</a>
      <a href="/agreement.html?type=PRIVATE">隐私政策</a>
      <a @click="goPage">投诉建议</a>
    </div>
    <div class="links">
      <a href="/about.html">关于我们</a>
      <a href="/agreement.html?type=PFRAUL" class="cheat">防骗指南</a>
      <a href="https://mp.weixin.qq.com/s/4A7LYSt19GWMoD1j6RjX-g" class="cheat">退费骗局</a>
      <a href="/quality-car.html">质检直通车</a>
      <a @click="goPage">投诉维权</a>
    </div>
    <div class="links">
      <a href="/copyright.html">版权告知函</a>
      <a>监督与举报邮箱: laixuefawu@126.com</a>
    </div>
    <div class="copyright">
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502008512">
        <!-- <img :src="`${staticUrl}ico-beian.png`"> -->
        <span>沪公网安备 31011502008512号</span>
      </a>
      <a href="http://beian.miit.gov.cn">沪ICP备14016521号-1</a>
    </div>
    <div class="copyright">版权所有 © 2008-2019，来学网（400-118-6070）</div>
    <div class="warning" v-if="isShowWarning" @touchmove.prevent>
      <div class="warning-model">
        <img :src="`${staticUrl}img-warning.png` | handleImageUrl('520', '550')" />
        <div class="btn-close" @click="onWarningClose">
          <img :src="`${staticUrl}ico-button-close.png` | handleImageUrl('85', '85')" />
        </div>
        <div class="cutdown">还有{{ cutdownTime }}秒关闭</div>
      </div>
    </div>
  </div>
</template>
<script>
let timerInterval = null; // warning弹出框定时器
export default {
  data() {
    return {
      domain: process.env.VUE_APP_DOMAIN,
      staticUrl: process.env.VUE_APP_CDN,
      isShowWarning: false, // warning弹出框是否显示
      cutdownTime: 20, // warning弹出框倒计时时间
    };
  },
  methods: {
    goPage() {
      window.location.href = `http://m.${process.env.VUE_APP_DOMAIN}/feedback.html`;
    },

    // 关闭提示弹框
    onWarningClose() {
      this.isShowWarning = false;
      clearInterval(timerInterval);
      this.cutdownTime = 20;
    },
  },
};
</script>
<style scoped>
/* issue 2131 */
.footer {
  padding: 40px 0 175px;
}

.links {
  display: flex;
  justify-content: space-around;
  margin-bottom: 30px;
}

.links a {
  color: #666;
  font-size: 24px;
  text-decoration: none;
}

.cheat {
  color: #f01212 !important;
  font-weight: 600;
}

.center {
  text-align: center;
}

.copyright {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 15px;
  font-size: 22px;
  color: #999;
}

.copyright img {
  float: left;
}

.copyright a {
  text-decoration: none;
  font-size: 22px;
  color: #999;
}

.copyright span {
  margin-left: 10px;
  margin-right: 20px;
}

.warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(40, 40, 40, 0.4);
  z-index: 999;
}

.warning-model {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
}

.warning-model img {
  display: block;
  width: 100%;
}

.warning-model .btn-close {
  position: absolute;
  top: -2%;
  right: -2%;
  width: 15%;
  height: 15%;
  border-radius: 50%;
}

.warning-model .btn-close img {
  display: block;
  width: 100%;
}

.warning-model .cutdown {
  position: absolute;
  bottom: 3.5%;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  font-size: 27px;
  text-align: center;
  color: #fff;
}
</style>
